import isString from 'lodash/isString'
import startCase from 'lodash/startCase'
import toLower from 'lodash/toLower'

const capitalizeName = title => {
  const excludeWords = [
    'de',
    'del',
    'y',
    'o',
    'a',
    'en',
    'el',
    'la',
    'los',
    'las',
    'un',
    'una',
    'unos',
    'unas',
    'con'
  ]

  if (!isString(title)) {
    return ''
  }

  const words = toLower(title).split(' ')
  const capitalizedWords = words.map((word, index) =>
    excludeWords.includes(word) && index !== 0 ? word : startCase(word)
  )

  const result = capitalizedWords.join(' ')
  const finalResult = result.charAt(0).toUpperCase() + result.slice(1)

  return finalResult
}

export default capitalizeName
